import { Directive, ElementRef, Input, AfterViewInit, HostListener, Renderer2, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[autoResizeText]',
  standalone: true
})
export class AutoResizeTextDirective implements AfterViewInit, OnChanges {
  @Input('autoResizeText') textContent: string = '';
  @Input('fontSize') initialFontSize: string = '3rem'; // Acepta el tamaño de fuente de las preferencias

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    this.adjustFontSize();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Se reajusta cada vez que el texto o el tamaño de fuente inicial cambian
    if (changes['textContent'] || changes['initialFontSize']) {
      // Usamos un pequeño timeout para asegurar que el DOM esté listo
      setTimeout(() => this.adjustFontSize(), 0);
    }
  }

  @HostListener('window:resize')
  onResize(): void {
    this.adjustFontSize();
  }

  private adjustFontSize(): void {
    const container = this.el.nativeElement.parentElement;
    const element = this.el.nativeElement;

    if (!container || !element) {
      return;
    }

    // 1. Resetear el tamaño de fuente al valor de las preferencias
    this.renderer.setStyle(element, 'font-size', this.initialFontSize);
    
    // 2. Extraer el valor numérico y la unidad
    const match = this.initialFontSize.match(/(\d*\.?\d+)(\D+)/);
    if (!match) {
        // Si el formato no es válido, no hacemos nada.
        return;
    }

    let fontSize = parseFloat(match[1]);
    const unit = match[2];

    // 3. Reducir el tamaño de la fuente si el contenido se desborda
    while (element.scrollHeight > container.clientHeight || element.scrollWidth > container.clientWidth) {
      if (fontSize <= 10) { // Límite mínimo para evitar que el texto desaparezca
        break;
      }
      fontSize -= 2;
      this.renderer.setStyle(element, 'font-size', `${fontSize}${unit}`);
    }
  }
}
